module.exports = __webpack_public_path__ + "img/11th_jobs-and-careers.68a694c1.webp";